import Phaser from "phaser";
import { IMAGES, MAPS, SOUNDS } from "../assets";
import { ASSETS_READY } from "../flow";
import { setAppState } from "./boot-scene";
import { SceneKey } from "./scene-keys";

const BAR_WIDTH = 320;
const BAR_HEIGHT = 12;

/** Loads every asset from the manifest while showing a progress bar. */
export class PreloadScene extends Phaser.Scene {
	private failed: string[] = [];

	constructor() {
		super(SceneKey.Preload);
	}

	preload(): void {
		this.createProgressBar();

		this.load.setPath("assets");
		for (const [key, path] of Object.entries(IMAGES)) this.load.image(key, path);
		// Without Web Audio, Phaser falls back to HTML5 Audio whose load events may never fire
		// (seen in Playwright's Windows WebKit), stalling the loader. Play silently instead.
		if (this.sound instanceof Phaser.Sound.WebAudioSoundManager) {
			for (const [key, path] of Object.entries(SOUNDS)) this.load.audio(key, path);
		} else {
			console.warn("Web Audio unavailable: sounds disabled.");
		}
		for (const [key, path] of Object.entries(MAPS)) this.load.text(key, path);

		this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file: Phaser.Loader.File) => {
			this.failed.push(file.key);
		});
	}

	create(): void {
		if (this.failed.length > 0) {
			setAppState("error");
			console.error(`Failed to load assets: ${this.failed.join(", ")}`);
			return;
		}
		setAppState("ready");
		// The GameFlow decides what comes next (main menu, or a match with `?play=`).
		this.game.events.emit(ASSETS_READY);
		this.scene.stop();
	}

	private createProgressBar(): void {
		const { width, height } = this.scale;
		const x = (width - BAR_WIDTH) / 2;
		const y = (height - BAR_HEIGHT) / 2;

		this.add.rectangle(x, y, BAR_WIDTH, BAR_HEIGHT).setOrigin(0).setStrokeStyle(1, 0x8090c0);
		const fill = this.add.rectangle(x + 2, y + 2, 0, BAR_HEIGHT - 4, 0xe8ecff).setOrigin(0);

		this.load.on(Phaser.Loader.Events.PROGRESS, (value: number) => {
			fill.width = (BAR_WIDTH - 4) * value;
		});
	}
}
